<template>
  <v-btn
    v-if="
      role(
        'admin',
        'departmentManager',
        'manager',
        'safetyRepresentative'
      )
    "
    @click="reset"
    class="primary accent-4 white--text mr-2 my-1"
    small
  >
    {{ $t("profile.assignment.resetPassword") }}
  </v-btn>
</template>

<script>
import ResetPasswordQuery from "../graphql/ResetPassword.gql";
import { mapGetters } from "vuex";

export default {
  props: ["id"],
  computed: {
    ...mapGetters(["role"]),
  },
  methods: {
    reset() {
      this.$apollo
        .mutate({
          mutation: ResetPasswordQuery,
          variables: {
            employeeId: this.id,
          },
        })
        .then(() => {
          this.$store.commit("push_global_message", {
            text: this.$i18n.t("profile.assignment.passwordReset"),
            color: "success",
          });
        });
    },
  },
};
</script>
